import { render, staticRenderFns } from "./subview_svc_call_list.vue?vue&type=template&id=ef3f735e&"
import script from "./subview_svc_call_list.vue?vue&type=script&lang=js&"
export * from "./subview_svc_call_list.vue?vue&type=script&lang=js&"
import style0 from "./subview_svc_call_list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VSheet,VSimpleTable})
